// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyFilledSvg from "@ant-design/icons-svg/es/asn/CopyFilled";
import AntdIcon from '../components/AntdIcon';

var CopyFilled = function CopyFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyFilledSvg
  }));
};

CopyFilled.displayName = 'CopyFilled';
export default React.forwardRef(CopyFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CopyFilled.js
// module id = 869
// module chunks = 0